import React, { FC } from 'react';
import { Input } from 'antd';
import styled from 'styled-components';

import { useDirection } from '~/hooks/i18nHooks';
import Hint from '../Hint';

interface Props {
  hintText?: string;
  type?: string;
}

const CustomInput: FC<Props> = (props) => {
  const { hintText, type, ...rest } = props;
  const dir = useDirection();

  return (
    <Container className="CustomInput" dir={dir}>
      <Input type={type} className="CustomInput-Input" {...rest} />
      {hintText && <Hint text={hintText} />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  .CustomInput-Input {
    margin-right: 8px;
  }
`;

export default CustomInput;
